import { createContext } from "react";

const InvoiceContext = createContext<any | undefined>(undefined);

export default InvoiceContext;
